// extracted by mini-css-extract-plugin
module.exports = {"header":"_18z-Cis","dark":"_2wuRzNQ"};